import script from "./Home1.vue?vue&type=script&setup=true&lang=js"
export * from "./Home1.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./Home1.vue?vue&type=style&index=1&id=9715a1a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9715a1a8"]])

export default __exports__